import TicketWorkLogs from './TicketWorkLogs';

export default TicketWorkLogs;
